import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
} from 'reactstrap';
import { AdminPreQualificationList } from '../models/preQualificationModel';
import { PreQualficationStatusBadge } from './PreQualificationStatusBadge';
import { PreQualificationStatus } from '../enums/PreQualificationEnum';
import {
  IconCalendar,
  IconCashBanknote,
  IconMoneybag,
  IconUser,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

interface Props {
  pq: AdminPreQualificationList;
}

const PreQualificationListCard = ({ pq }: Props) => {
  const navigate = useNavigate();
  const { id, borrower, borrower_project, banking_offers, status, created_at } =
    pq;

  return (
    <Card>
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0 text-capitalize">
            {borrower.first_name} {borrower.last_name} - {borrower.phone}
          </CardTitle>
          <PreQualficationStatusBadge
            status={status as PreQualificationStatus}
          />
        </div>
        <small className="text-muted">{borrower_project.property_info}</small>
      </CardHeader>
      <CardBody>
        <Row className="mb-3">
          <Col md={6}>
            <div className="d-flex align-items-center">
              <IconMoneybag size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Monto solicitado</small>
                <div className="fw-bold">
                  {borrower_project.requested_loan_amount}
                </div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex align-items-center">
              <IconCalendar size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Generado</small>
                <div className="fw-bold">{created_at}</div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div className="d-flex align-items-center">
              <IconUser size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Score</small>
                <div className="fw-bold">{borrower?.score ?? 'ND'}</div>
              </div>
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex align-items-center">
              <IconCashBanknote size={16} className="text-primary me-2" />
              <div>
                <small className="text-muted">Ofertas bancarias</small>
                <div className="fw-bold">{banking_offers} Disponibles</div>
              </div>
            </div>
          </Col>
        </Row>
        <Button
          color="primary"
          block
          onClick={() => {
            navigate(`/pre-qualification/${id}`);
          }}
        >
          Ver Detalle
        </Button>
      </CardBody>
    </Card>
  );
};

export default PreQualificationListCard;
